// ===================================================================
// Config.js - ملف الإعدادات المركزي لمشروع GeoPST
// ===================================================================
// هذا الملف يحتوي على جميع الثوابت والإعدادات المستخدمة في المشروع
// لتسهيل الصيانة والتعديل المستقبلي

/* ===============================================
   إعدادات GeoServer
   =============================================== */
export const GEOSERVER_BASE_URL = '/api/gis/geoserver'; // Secure proxy for data queries
export const GEOSERVER_EXTERNAL_URL = 'https://geopst.com/geoserver'; // Direct for tile visual rendering

export const GEOSERVER_WMS_URL = `${GEOSERVER_EXTERNAL_URL}/wms`; // Fast direct tiles
export const GEOSERVER_WFS_URL = `${GEOSERVER_BASE_URL}/ows`; // Secure data queries (Identify/Search)
export const GEOSERVER_WMTS_URL = `${GEOSERVER_EXTERNAL_URL}/gwc/service/wmts`; // Fast cached tiles

/* ===============================================
   إعدادات الإسقاط الخرائطي (Projection)
   =============================================== */
export const MAP_PROJECTION_CODE = 'EPSG:28191';
export const GEOMOLG_RESOLUTIONS = [
  529.1677250021168, 264.5838625010584, 132.2919312505292,
  66.1459656252646, 33.0729828126323, 16.933367200067735,
  8.466683600033868, 4.233341800016934, 2.116670900008467,
  1.0583354500042335, 0.5291677250021167, 0.26458386250105836,
  0.13229193125052918, 0.06614596562526459
];
export const MAP_PROJECTION_DEF =
  '+proj=cass +lat_0=31.7340969444444 +lon_0=35.2120805555556 ' +
  '+x_0=170251.555 +y_0=126867.909 ' +
  '+a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1.0 +units=m +no_defs';

/* ===============================================
   إعدادات طبقات GeoServer
   =============================================== */
export const LAYERS = {
  PARCEL: {
    name: 'Parcel',
    workspace: 'DataBase',
    layer: 'New_Parcel',
    fullName: 'DataBase:New_Parcel',
    title: 'قطع ارضي',
    description: 'حدود قطع الأراضي التسوية',
    icon: 'fa-solid fa-draw-polygon',
    visible: true
  },
  BLOCKS_NON_REGISTERED: {
    name: 'Blocks_Non_Registered',
    workspace: 'DataBase',
    layer: 'blocks_non_registered',
    fullName: 'DataBase:blocks_non_registered',
    title: 'احواض طبيعية',
    description: 'حدود الاحواض الطبيعية',
    icon: 'fa-solid fa-vector-square',
    visible: false
  },
  COLONIES_BORDER: {
    name: 'Colonies_Border',
    workspace: 'DataBase',
    layer: 'Colonies_Border',
    fullName: 'DataBase:Colonies_Border',
    title: 'حدود المستوطنات',
    description: 'حدود المستوطنات',
    icon: 'fa-solid fa-exclamation-triangle',
    visible: true // Visible on map, but hidden from UI via HIDDEN_LAYER_NAMES
  },
  BORDER_PALESTINE_NEAR: {
    name: 'Border_Palestine_Near',
    workspace: 'DataBase',
    layer: 'Border_Palestine_Near',
    fullName: 'DataBase:Border_Palestine_Near',
    title: 'حدود فلسطين',
    visible: true
  },
  WESTBANK_GAZA_BORDER: {
    name: 'WestBank_Gaza_Border',
    workspace: 'DataBase',
    layer: 'WestBank_Gaza_Border',
    fullName: 'DataBase:WestBank_Gaza_Border',
    title: 'حدود الضفة وغزة',
    visible: true
  },
  URBAN_MASTER: {
    name: 'UrbanMaster_2025',
    workspace: 'DataBase',
    layer: 'UrbanMaster_2025',
    fullName: 'DataBase:UrbanMaster_2025',
    title: 'المخطط الهيكلي',
    description: 'المخطط الهيكلي',
    icon: 'fa-solid fa-map',
    visible: false
  },

  ABC_AREAS: {
    name: 'ABC_Areas',
    workspace: 'DataBase',
    layer: 'ABC_Areas',
    fullName: 'DataBase:ABC_Areas',
    title: 'التقسيم الجيوسياسي',
    description: 'التقسيم الجيوسياسي',
    icon: 'fa-solid fa-map-signs',
    visible: false
  },
  BUILDING: {
    name: 'Buildings',
    workspace: 'DataBase',
    layer: 'building',
    fullName: 'DataBase:building',
    title: 'المباني',
    description: 'حدود المباني',
    icon: 'fa-solid fa-building',
    visible: false
  },
  GOVERNORATE: {
    name: 'governorate',
    workspace: 'DataBase',
    layer: 'governorate',
    fullName: 'DataBase:governorate',
    visible: true
  },
  VILLAGE: {
    name: 'village',
    workspace: 'DataBase',
    layer: 'village',
    fullName: 'DataBase:village',
    visible: true
  },
  PARCEL_GOV: {
    workspace: 'DataBase',
    layer: 'parcel_gov',
    fullName: 'DataBase:parcel_gov'
  },
  PARCEL_VILLAGE: {
    workspace: 'DataBase',
    layer: 'parcel_village',
    fullName: 'DataBase:parcel_village'
  },
  IMAGERY_1970: {
    workspace: 'DataBase',
    layer: 'ImageryWB1970',
    fullName: 'DataBase:ImageryWB1970'
  },
  CENTROIDS: {
    name: 'Centroids',
    workspace: 'DataBase',
    layer: 'centroids',
    fullName: 'DataBase:centroids',
    title: 'النقاط المركزية',
    visible: true
  }
};

/* ===============================================
   إعدادات ArcGIS Services
   =============================================== */
export const ARCGIS_SERVICES = {
  IMAGERY_2023: 'https://orthophotos.geomolg.ps/adaptor/rest/services/Orthophotos_WB_2023_15cm_jp2_PG1923_jp2/MapServer',
  WORLD_IMAGERY: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer'
};

// خدمات orthophotos.geomolg.ps
export const GEOMOLG_HOST = 'orthophotos.geomolg.ps';
export const ORTHOPHOTOS_BASE = `https://${GEOMOLG_HOST}/adaptor/rest/services`;
export const ORTHOPHOTOS_SERVICES = {
  2025: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2025_15cm_tif_PG1923/MapServer`,
  2024: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2024_15cm_tif_PG1923/MapServer`,
  2022: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2022_15cm_tif_PG1923_05/MapServer`,
  2021: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2021_15cm_tif_PG1923/MapServer`,
  2020: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2020_25cm_jpg_PG1923/MapServer`,
  2019: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2019_Aerial_25cm_jpg_PG1923/MapServer`,
  2018: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2018_Aerial_10cm_jpg_PG1923/MapServer`,
  2016: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2016_Aerial_10cm_jpg_PG1923/MapServer`,
  2015: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2015_Aerial_25cm_jpg_PG1923/MapServer`,
  2014: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2014_Aerial_25cm_jpg_PG1923/MapServer`,
  2013: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2013_Aerial_50cm_jpg_PG1923/MapServer`,
  2012: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2012_Aerial_50cm_jpg_PG1923/MapServer`,
  2011: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2011_Aerial_50cm_jpg_PG1923/MapServer`,
  2010: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2010_Aerial_50cm_jpg_PG1923/MapServer`,
  2009: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2009_Aerial_50cm_jpg_PG1923/MapServer`,
  2008: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2008_Aerial_50cm_jpg_PG1923/MapServer`,
  2006: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2006_Aerial_50cm_jpg_PG1923/MapServer`,
  2005: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2005_Aerial_75cm_jpg_PG1923/MapServer`,
  2004: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2004_Aerial_100cm_jpg_PG1923/MapServer`,
  2003: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2003_Aerial_100cm_jpg_PG1923/MapServer`,
  2002: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2002_Aerial_80cm_jpg_PG1923/MapServer`,
  2001: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2001_Aerial_100cm_jpg_PG1923/MapServer`,
  2000: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_2000_Aerial_80cm_jpg_PG1923/MapServer`,
  1999: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_1999_Aerial_125cm_jpg_PG1923/MapServer`,
  1997: `${ORTHOPHOTOS_BASE}/Orthophotos_WB_1997_Aerial_125cm_jpg_PG1923/MapServer`
};

/* ===============================================
   إعدادات الخريطة الافتراضية
   =============================================== */
export const GAZA_IMAGERY_SERVICES = {
  2004: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_2004_Satellite_100cm_jpg_PG1923/MapServer`,
  2005: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_2005_Satellite_100cm_jpg_PG1923/MapServer`,
  201407: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_201407_Satellite_50cm_jp2_PG1923/MapServer`,
  2014: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_201407_Satellite_50cm_jp2_PG1923/MapServer`,
  201408: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_201408_Satellite_50cm_jp2_PG1923/MapServer`,
  2015: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_201408_Satellite_50cm_jp2_PG1923/MapServer`,
  2018: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_2018_Satellite_50cm_TIF_PG1923/MapServer`,
  201811: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_201811_Satellite_50cm_jpg_PG1923/MapServer`,
  2019: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_201811_Satellite_50cm_jpg_PG1923/MapServer`,
  2021: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_2021_Satellite_52cm_jp2_PG1923/MapServer`,
  2022: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_2022_Satellite_40cm_jp2_PG1923/MapServer`,
  2024: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_2024_m12_Satellite_tif_PG1923/MapServer`,
  2025: `${ORTHOPHOTOS_BASE}/Orthophotos_GS_2025_m03_Satellite_tif_PG1923/MapServer`
};

export const REGION_EXTENTS = {
  GAZA: [71764.6001, 61990.8823, 112405.3473, 116596.0158], // [MinX, MinY, MaxX, MaxY]
  WEST_BANK: [124443.4205, 80073.9090, 213080.3104, 219087.1607]
};

/* ===============================================
   إعدادات الخريطة الافتراضية
   =============================================== */
export const MAP_CONFIG = {
  // المركز الافتراضي الجديد: X: 153871.035, Y: 105930.57
  defaultCenter: [153871.035, 105930.57],
  // نحن نريد مقياس 1:2,000,000 -> Resolution = 560
  // لكن أقرب مستوى مدعوم في الـ Tiles هو 529.16 (1:1.88M)
  defaultResolution: 529.1677250021168,
  defaultZoom: 0,
  minZoom: 0,
  maxZoom: 13,
  STANDARD_PARCEL_ZOOM: 11, // المستوى الذهبي (1:1000)
  STANDARD_PARCEL_SCALE: 1000
};

/* ===============================================
   إعدادات WMS & WFS
   =============================================== */
export const WMS_PARAMS = {
  VERSION: '1.1.1',
  FORMAT: 'image/png', // ⚡ PNG ensures wide compatibility and transparency support
  TILED: true,
  TRANSPARENT: true
};

export const WFS_PARAMS = {
  SERVICE: 'WFS',
  VERSION: '1.1.0',
  REQUEST: 'GetFeature',
  OUTPUT_FORMAT: 'application/json'
};

/* ===============================================
   ثوابت واجهة المستخدم
   =============================================== */
export const UI_CONFIG = {
  // الألوان الأساسية
  primaryColor: '#dc3545',
  darkColor: '#c82333',
  // مدة الرسوم المتحركة (بالملي ثانية)
  animationDuration: 300,
  // حجم العدسة المكبرة
  magnifierSize: 140,
  // معامل التكبير للعدسة
  magnifierScale: 1.3
};

/* ===============================================
   الطبقات المخفية من واجهة إدارة الطبقات
   =============================================== */
export const HIDDEN_LAYER_NAMES = [
  'MeasureLayer',
  'GeolocationLayer',
  'DrawLayer',
  'ConvertedCoordinates',
  'governorate',
  'village',
  'Colonies_Border',
  'Border_Palestine_Near',
  'WestBank_Gaza_Border',
  'Centroids'
];

/* ===============================================
   إعدادات البحث
   =============================================== */
export const SEARCH_CONFIG = {
  // الحد الأقصى للنتائج في البحث العام
  maxFeaturesGeneral: 50,
  // الحد الأقصى للنتائج في البحث الضيق
  maxFeaturesNarrow: 2000,
  // الحد الأقصى لعدد العناصر في الـ Autocomplete
  autocompleteLimit: 1000
};

/* ===============================================
   روابط OpenStreetMap
   =============================================== */
export const OSM_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

/* ===============================================
   تصدير كائن واحد يحتوي على كل الإعدادات (اختياري)
   =============================================== */
export default {
  geoserver: {
    baseUrl: GEOSERVER_BASE_URL,
    wms: GEOSERVER_WMS_URL,
    wfs: GEOSERVER_WFS_URL,
    wmts: GEOSERVER_WMTS_URL
  },
  projection: {
    code: MAP_PROJECTION_CODE,
    def: MAP_PROJECTION_DEF
  },
  layers: LAYERS,
  arcgis: ARCGIS_SERVICES,
  orthophotos: ORTHOPHOTOS_SERVICES,
  map: MAP_CONFIG,
  wms: WMS_PARAMS,
  wfs: WFS_PARAMS,
  ui: UI_CONFIG,
  hiddenLayers: HIDDEN_LAYER_NAMES,
  search: SEARCH_CONFIG,
  osm: OSM_TILE_URL
};
